/**
 * Adds element in the array at specific position without overriding element on that position by pushing
 * the target element one place/index on the right.
 *
 * @param arrayData - array where element needs to be added
 * @param element  - element that needs to be added in the array
 * @param position - index of a position where element needs to be added.
 *
 * @returns Returns new version of the array since it doesn't mutate the provided one.
 */

export function addElementInArray<ArrayDataType>(
  arrayData: ArrayDataType[],
  element: ArrayDataType,
  position: number,
): ArrayDataType[] {
  const _arrayData = [...arrayData];
  const firstHalf = _arrayData.slice(0, position);
  const secondHalf = _arrayData.slice(position);

  return [...firstHalf, element, ...secondHalf];
}
